import React from "react";
import { Link } from "react-router-dom";
import { useSeo } from "../lib/seo";
import { useLang } from "../lib/lang";

export default function NotFound() {
  const { t } = useLang();
  useSeo({
    title: "404 — Page not found · Brand and Behavior",
    description: "This page does not exist. Return to Brand and Behavior.",
    noindex: true,
  });

  return (
    <main className="notfound-page" data-testid="not-found-page" style={{
      minHeight: "70vh",
      padding: "160px 22px 120px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#fff",
    }}>
      <div style={{ maxWidth: 640, textAlign: "left" }}>
        <div style={{
          fontSize: 10,
          letterSpacing: ".28em",
          textTransform: "uppercase",
          color: "#7a7a72",
          marginBottom: 20,
        }}>404 · Not found</div>
        <h1 style={{
          fontSize: "clamp(44px, 6vw, 84px)",
          lineHeight: 1,
          letterSpacing: "-.04em",
          margin: 0,
          fontWeight: 500,
        }}>
          {t("This page ", "Esta página ")}
          <em style={{ fontFamily: "'Instrument Serif', serif", fontStyle: "italic" }}>
            {t("doesn't exist", "no existe")}
          </em>.
        </h1>
        <p style={{
          marginTop: 28,
          fontSize: 16,
          lineHeight: 1.6,
          color: "#4a4a44",
          maxWidth: 520,
        }}>
          {t(
            "The link you followed is either outdated or was never part of Brand and Behavior. Nothing to see here.",
            "El enlace al que llegaste está obsoleto o nunca fue parte de Brand and Behavior. Nada que ver aquí."
          )}
        </p>
        <div style={{ marginTop: 36, display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Link to="/" className="pill solid" data-testid="notfound-home">
            {t("Back to home", "Volver al inicio")}
          </Link>
          <Link to="/services" className="pill ghost" data-testid="notfound-services">
            {t("See services", "Ver servicios")}
          </Link>
        </div>
      </div>
    </main>
  );
}
